import { chargeAppliedBalance, chargeCash, noPaymentSelected } from 'api/Transaction';

import { iaRa } from 'lib/helpers/utility';
import { requiredMsg } from 'lib/constants/messages';

import { showAlert } from 'components/shared/Alert/Alert';

const withNote = (reference, note) => [reference, note].filter(Boolean).join(' — ');

export const chargeOutsideFinancingHandler = (
  navigate,
  {
    invoices,
    patientId,
    appointmentId,
    surchargeAmount,
    gratuity,
    amount,
    appliedBalance,
    methodDetail,
    checkin,
    planId,
    scheduleId,
    transactionTags,
    note
  }
) => {
  if (!methodDetail) {
    showAlert({
      title: requiredMsg('Outside financing number'),
      color: 'danger'
    });
    return;
  }

  return chargeCash(navigate, {
    invoices,
    patientId,
    appointmentId,
    checkin,
    planId,
    scheduleId,
    transactionTags,
    transaction: {
      appliedBalance,
      surcharge_amount: surchargeAmount,
      gratuity,
      amount: { value: amount, currency: 'USD' },
      note: withNote(`Outside Financing Number: ${methodDetail}`, note),
      type: 'care_credit'
    }
  });
};

export const chargeCheckHandler = (
  navigate,
  {
    invoices,
    patientId,
    appointmentId,
    surchargeAmount,
    gratuity,
    amount,
    methodDetail,
    invoiceId,
    practiceId,
    checkin,
    appliedBalance,
    planId,
    scheduleId,
    transactionTags,
    note
  }
) => {
  if (!methodDetail) return;

  return chargeCash(navigate, {
    invoices,
    patientId,
    invoiceId,
    practiceId,
    appointmentId,
    checkin,
    planId,
    scheduleId,
    transactionTags,
    transaction: {
      appliedBalance,
      amount: { value: amount, currency: 'USD' },
      surcharge_amount: surchargeAmount,
      gratuity,
      note: withNote(`Check Number: ${methodDetail}`, note),
      type: 'check'
    }
  });
};

export const chargeCashHandler = (
  navigate,
  {
    invoices,
    patientId,
    appointmentId,
    surchargeAmount,
    gratuity,
    amount,
    invoiceId,
    practiceId,
    invoiceToken,
    payerId,
    checkin,
    appliedBalance,
    planId,
    scheduleId,
    transactionTags,
    note
  }
) => {
  return chargeCash(navigate, {
    invoices,
    patientId,
    invoiceId,
    practiceId,
    invoiceToken,
    appointmentId,
    surcharge_amount: surchargeAmount,
    checkin,
    planId,
    scheduleId,
    transactionTags,
    transaction: {
      appliedBalance,
      surcharge_amount: surchargeAmount,
      gratuity,
      amount: { value: amount, currency: 'USD' },
      note: note || '',
      type: 'cash',
      payer_id: payerId
    }
  });
};

export const noPaymentSelectedHandler = async (
  navigate,
  { appointmentId, invoices, deferredPaymentMethod = null }
) => {
  const appointmentIds = [
    ...new Set(
      [appointmentId, ...iaRa(invoices).map((invoice) => invoice?.appointment_id)].filter(Boolean)
    )
  ];
  const primaryAppointmentId = appointmentIds[0] ?? null;

  // Deferring records "no payment" against a visit; with no visit there is nothing to defer.
  if (!primaryAppointmentId) return { code: 0, noPaymentSelected: true };

  const response = await noPaymentSelected(navigate, {
    id: primaryAppointmentId,
    appointmentId: primaryAppointmentId,
    appointmentIds,
    deferredPaymentMethod
  });

  if (response?.code !== 0) return response;

  return { ...response, noPaymentSelected: true };
};

export const appliedBalanceHandler = (
  navigate,
  { appliedBalance, amount, invoices, patientId, practiceId }
) => {
  return chargeAppliedBalance(navigate, {
    appliedBalance,
    amount,
    invoices,
    patientId,
    practiceId
  });
};
